import React from 'react';
import { XIcon } from 'lucide-react';
const pains = ['Sunday night, building Monday’s lesson from scratch — again', 'Kids drifting off five minutes into your talk at the demo board', 'Puzzles too easy for half the room and too hard for the rest', 'A 50-minute meeting and no clear plan for what fills it', 'Not a strong player yourself, and worried a kid will catch you on a rule', 'Refereeing castling, en passant and touch-move fights instead of teaching', '30 kids, 8 boards, and somebody always waiting with nothing to do', 'No real progression — just “play a game” week after week'];
export function PainGrid() {
  return <section aria-labelledby="pain-heading" className="w-full bg-navy-deep" data-id="element-157" data-mp="1bq4b7pi39vfg">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-158" data-mp="17pkf8p994xuw">
        <div className="text-center" data-id="element-159" data-mp="364dpa8x8hztw">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-160" data-mp="363c0z2r7jgu8">
            The club-coach reality
          </p>
          <h2 id="pain-heading" className="chalk-underline mt-3 font-display text-white text-[28px] sm:text-4xl md:text-5xl leading-tight" data-id="element-161" data-mp="320fs43rgyz3h">
            If you run a chess club, you know at least{' '}
            <span className="text-crimson-soft" data-id="element-162" data-mp="3796t6kvw9o4u">half of this list.</span>
          </h2>
        </div>

        <ul className="mt-9 grid gap-3 text-left sm:grid-cols-2 sm:gap-x-5" data-id="element-163" data-mp="3b98lw4jnj77z">
          {pains.map(pain => <li key={pain} className="flex items-start gap-3 rounded-xl border border-navy-line bg-navy-card px-4 py-4 text-sm text-white/85" data-id="element-164" data-mp="2v8f5dv8cw35">
              <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-crimson/20" data-id="element-165" data-mp="3q82k9ncghmeg">
                <XIcon className="h-3 w-3 text-crimson-soft" aria-hidden="true" data-id="element-166" data-mp="3u7jrombg0tm9" />
              </span>
              {pain}
            </li>)}
        </ul>

        <p className="chalk-note mt-9 text-center text-2xl sm:text-3xl text-gold leading-tight" data-id="element-167" data-mp="ql2mjfws5sg0">
          How many more sessions do you want to build from scratch?
        </p>
      </div>
    </section>;
}